document.documentElement.classList.remove("no-js");

(function () {
  const galleries = document.querySelectorAll("[data-product-gallery]");

  function money(cents) {
    if (typeof cents !== "number") return "";
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "AUD" }).format(cents / 100);
  }

  galleries.forEach((gallery) => {
    const productLayout = gallery.closest(".product-layout") || document;
    const form = productLayout.querySelector("[data-product-form]");
    const mainImage = gallery.querySelector("[data-main-product-image]");
    const thumbs = Array.from(gallery.querySelectorAll("[data-product-thumb]"));
    const imageTrigger = gallery.querySelector("[data-product-image-trigger]");
    const modal = gallery.querySelector("[data-product-image-modal]");
    const modalImage = gallery.querySelector("[data-product-modal-image]");
    const closeButtons = gallery.querySelectorAll("[data-product-image-close]");

    function setActiveImage(src, alt, activeThumb) {
      if (!mainImage) return;
      if (src) mainImage.src = src;
      if (alt) mainImage.alt = alt;
      thumbs.forEach((thumb) => thumb.classList.toggle("is-active", thumb === activeThumb));
      if (modalImage) {
        modalImage.src = mainImage.currentSrc || mainImage.src;
        modalImage.alt = mainImage.alt;
      }
    }

    thumbs.forEach((btn) => {
      btn.addEventListener("click", () => {
        setActiveImage(btn.getAttribute("data-full-src") || mainImage?.src, btn.getAttribute("data-alt") || mainImage?.alt, btn);
      });
    });

    if (imageTrigger && modal && modalImage && mainImage) {
      imageTrigger.addEventListener("click", () => {
        modal.hidden = false;
        document.body.classList.add("modal-open");
        modalImage.src = mainImage.currentSrc || mainImage.src;
        modalImage.alt = mainImage.alt;
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
          modal.hidden = true;
          document.body.classList.remove("modal-open");
        });
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !modal.hidden) {
          modal.hidden = true;
          document.body.classList.remove("modal-open");
        }
      });
    }

    if (!form) return;

    const variantJson = form.querySelector("[data-variant-json]");
    let variants = [];
    try {
      variants = JSON.parse(variantJson?.textContent || "[]");
    } catch (e) {}

    const selects = Array.from(form.querySelectorAll("[data-product-option]"));
    const variantInput = form.querySelector("[data-variant-id]");
    const priceEl = productLayout.querySelector("[data-product-price]");
    const compareEl = productLayout.querySelector("[data-compare-at-price]");
    const statusEl = productLayout.querySelector("[data-product-status]");
    const addButton = form.querySelector("[data-add-to-cart]");
    const addButtonText = form.querySelector("[data-add-to-cart-text]");

    function findVariant() {
      if (!variants.length) return null;
      const values = selects.map((select) => select.value);
      return variants.find((variant) => (variant.options || []).every((option, index) => option === values[index])) || variants[0];
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl && typeof variant.price === "number") priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (typeof variant.compare_at_price === "number" && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = money(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = "";
        }
      }
      if (statusEl) statusEl.textContent = variant.available ? "In stock" : "Sold out";
      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) addButtonText.textContent = variant.available ? "Add to cart" : "Sold out";
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        const matchedThumb = thumbs.find((thumb) => (thumb.getAttribute("data-full-src") || "").indexOf(variant.featured_image.src) !== -1);
        setActiveImage(variant.featured_image.src, mainImage.alt, matchedThumb || null);
      }
    }

    selects.forEach((select) => select.addEventListener("change", updateVariant));
    updateVariant();
  });
})();
